import { InfoWhiteIcon, LogoutWhiteIcon, OrderIcon, ReservationIcon, UserWhiteIcon } from "../../../assets/icons";
import { UserType } from "../../../models/base/UserType";
import ImageModalTrigger from "../../shared/ImageModalTrigger";

interface ClientMenuHeaderProps {
    user: any;
    primaryColor: string;
    logoImageUrl: string;
    backgroundImageUrl: string;
    localName: string;
    localAddress: string;
    planSubscriptionFeatures: string[];
    localId: string;
    navigate: any;
    setIsReservationViewOpen: (isOpen: boolean) => void;
    setIsClientOrdersViewOpen: (isOpen: boolean) => void;
    setIsLocalInfoViewOpen: (isOpen: boolean) => void;
}


export default function ClientMenuHeader({ user, primaryColor, planSubscriptionFeatures, localId, navigate, logoImageUrl, backgroundImageUrl, localName, localAddress, setIsReservationViewOpen, setIsClientOrdersViewOpen, setIsLocalInfoViewOpen }: ClientMenuHeaderProps) {

    return (
        <section className="client-header-section">
            <div className="w-layout-blockcontainer container client-header w-container">
                <div className="client-header-wrapper">
                    <div className="client-header-nav-buttons-list">
                        {user && user.type === UserType.Client ? (
                            <div className="client-header-nav-button-div" style={{ background: primaryColor }} onClick={() => navigate('/client-profile')}>
                                <img loading="lazy" src={UserWhiteIcon} alt="" />
                            </div>
                        ) : (
                            <div className="client-header-nav-button-div" style={{ background: primaryColor }} onClick={() => navigate('/login', { state: { from: window.location.pathname } })}>
                                <img loading="lazy" src={LogoutWhiteIcon} alt="" />
                            </div>
                        )}

                        {planSubscriptionFeatures.includes("plus-reservation") && (
                            <div className="client-header-nav-button-div" onClick={() => setIsReservationViewOpen(true)} style={{ background: primaryColor }}>
                                <img loading="lazy" src={ReservationIcon} alt="" />
                            </div>
                        )}

                        {planSubscriptionFeatures.some(f => f.startsWith("plus-order")) && (
                            <div className="client-header-nav-button-div" onClick={() => setIsClientOrdersViewOpen(true)} style={{ background: primaryColor }}>
                                <img loading="lazy" src={OrderIcon} alt="" />
                            </div>
                        )}

                        <div className="client-header-nav-button-div" onClick={() => setIsLocalInfoViewOpen(true)} style={{ background: primaryColor }}>
                            <img loading="lazy" src={InfoWhiteIcon} alt="" />
                        </div>
                    </div>
                    <div className="client-header-local-info-block">
                        <div className="client-header-local-photo">
                            <ImageModalTrigger url={logoImageUrl.includes(localId) ? logoImageUrl + "@ul.webp" : logoImageUrl} altText="Restoran Zlatna Lađa">
                                <img loading="lazy" src={logoImageUrl.includes(localId) ? logoImageUrl + "@ul.webp" : logoImageUrl} alt="" />
                            </ImageModalTrigger>
                        </div>
                        <div className="client-header-local-info">
                            <div className="client-header-local-name">{localName}</div>
                            <div className="client-header-local-street-adress">{localAddress}</div>
                        </div>
                    </div>
                    <div className="client-header-bg-photo-div">
                        <img loading="lazy" src={backgroundImageUrl.includes(localId) ? backgroundImageUrl + "@ul.webp" : backgroundImageUrl} alt="" className="client-header-bg-photo" />
                        <div className="client-header-bg-photo-hover">
                            <ImageModalTrigger url={backgroundImageUrl.includes(localId) ? backgroundImageUrl + "@ul.webp" : backgroundImageUrl} altText="Restoran Zlatna Lađa">
                            </ImageModalTrigger>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
